module.exports = __webpack_public_path__ + "img/60k_more_bank_logos.83899d08.png";